<div id="viewer-section">
  <div class="dashboard-heading ">
    <h2>{{ 'agent.metricsPage.heading' | translate:{ username: agent?.username } }}</h2>
  </div>

  <div id="dashboard" class="axede-gradient-bg"></div>
</div>

